import React, { useState, useEffect } from 'react';
import InfoWidgetInviteAndMetrics from './InfoWidgetViews/InfoWidgetInviteAndMetrics';
import InfoWidgetStart from './InfoWidgetViews/InfoWidgetStart';
import InfoWidgetCollectionApplication from './InfoWidgetViews/InfoWidgetCollectionApplication';

const InfoWidget = ({collectionsInfoWidgetPath, currentUserId, isQualifiedForCollectionApplication}) => {

  const [publishedCount, setPublishedCount] = useState(0);
  const [infoWidget, setInfoWidget] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInfoWidget();
  }, [])

  const fetchInfoWidget = () => {
    setLoading(true)
    $.ajax({
      type: 'GET',
      url: collectionsInfoWidgetPath,
      success: function(res) {
        setPublishedCount(res.publishedCollectionsCount)
        setInfoWidget(res);
        setLoading(false);
      }
    })
  }
  
  const renderInfoWidget = () => {
    if (!loading) {
      if (publishedCount === 0) {
        if (isQualifiedForCollectionApplication) {
          return <InfoWidgetCollectionApplication />
        }
        return <InfoWidgetStart />
      } else {
        return <InfoWidgetInviteAndMetrics infoWidget={infoWidget} currentUserId={currentUserId}/>
      }
    }
  }
  
  return (
    <div className="large-3 small-12 medium-12 columns new-info-widget-section">
      <div className="small-12 columns no-padding">
        {renderInfoWidget()}
      </div>
    </div>
  )
}

export default InfoWidget;